/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Board_FrameInputs */

const cs_pipelines_board_frame = /** @type {(inputs: Pipelines_Board_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nástěnka`)
};

const en_pipelines_board_frame = /** @type {(inputs: Pipelines_Board_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

/**
* | output |
* | --- |
* | "Board" |
*
* @param {Pipelines_Board_FrameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_board_frame = /** @type {((inputs?: Pipelines_Board_FrameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Board_FrameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_board_frame(inputs)
	return cs_pipelines_board_frame(inputs)
});